const themes = {
  common: {
    ports: {
      route: {
        color: '#f80',
      },
      string: {
        color: '#080',
      },
      number: {
        color: '#08f',
      },
      api: {
        color: '#088',
      },
      boolean: {
        color: '#f5a623',
      },
      list: {
        color: '#888',
      },
      datetime: {
        color: '#880',
      },
      object: {
        color: '#444',
      },
      'cfg-reengajamento': {
        color: '#f80',
      },
    },
    connections: {
      route: {
        color: '#f80',
      },
      string: {
        color: '#080',
      },
      number: {
        color: '#08f',
      },
      api: {
        color: '#088',
      },
      boolean: {
        color: '#f5a623',
      },
      list: {
        color: '#888',
      },
      datetime: {
        color: '#880',
      },
      object: {
        color: '#444',
      },
      'cfg-reengajamento': {
        color: '#f80',
      },
    },
    nodes: {
      start: {
        title: {
          background: '#080',
          color: 'white',
        },
      },
      end: {
        title: {
          background: 'purple',
          color: 'white',
        },
      },
      endWon: {
        title: {
          background: '#3F3',
          color: 'white',
        },
      },
      endLost: {
        title: {
          background: '#F33',
          color: 'white',
        },
      },
      voiceEnd: {
        title: {
          background: 'purple',
          color: 'white',
        },
      },
      api: {
        title: {
          background: '#008',
          color: 'white',
        },
      },
      apiCallV2: {
        title: {
          background: '#008',
          color: 'white',
        },
      },
      apiIntegration: {
        title: {
          background: '#008',
          color: 'white',
        },
      },
      subfluxoEntrada: {
        title: {
          background: '#00CED1',
          color: 'white',
        },
      },
      subfluxoSaida: {
        title: {
          background: '#00CED1',
          color: 'white',
        },
      },
      validadorEntrada: {
        title: {
          background: '#1E6FD9',
          color: 'white',
        },
      },
      validadorAceitar: {
        title: {
          background: '#0A8F4D',
          color: 'white',
        },
      },
      validadorRejeitar: {
        title: {
          background: '#C0392B',
          color: 'white',
        },
      },
    },
  },
};

export default themes;
